import { render } from "./ChannelSubscriptionMessage.vue?vue&type=template&id=0eb183dc"
import script from "./ChannelSubscriptionMessage.vue?vue&type=script&lang=ts"
export * from "./ChannelSubscriptionMessage.vue?vue&type=script&lang=ts"
script.render = render

export default script